import React, { useEffect } from "react";
import {
  Authenticator,
  ThemeProvider,
  Theme,
} from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { useAuthStore } from "@/stores/authStore";

// Mirrors the tokens in src/index.css. Amplify's theme system can't read CSS
// variables, so the brand values are repeated here as literals.
const ink = "#1C2321";
const inkMuted = "#6B7470";
const hairline = "#E6E4DD";
const pearGreen = "#1F5A4E";
const pearGreenHover = "#17463D";

const theme: Theme = {
  name: "pear",
  tokens: {
    fonts: {
      default: {
        variable: '"Inter Variable", ui-sans-serif, system-ui, sans-serif',
        static: '"Inter Variable", ui-sans-serif, system-ui, sans-serif',
      },
    },
    colors: {
      font: { primary: ink, secondary: inkMuted },
      border: { primary: hairline, focus: pearGreen },
    },
    components: {
      authenticator: {
        router: { boxShadow: "none", borderWidth: "0px" },
        form: { padding: "2rem" },
      },
      card: { backgroundColor: "white" },
      fieldcontrol: {
        borderColor: hairline,
        borderRadius: "0.5rem",
        _focus: { borderColor: pearGreen, boxShadow: `0 0 0 1px ${pearGreen}` },
      },
      tabs: {
        item: {
          color: inkMuted,
          _active: { borderColor: pearGreen, color: pearGreen },
          _hover: { color: ink },
        },
      },
      button: {
        borderRadius: "0.5rem",
        primary: {
          backgroundColor: pearGreen,
          color: "white",
          _hover: { backgroundColor: pearGreenHover },
          _focus: { backgroundColor: pearGreenHover, boxShadow: `0 0 0 2px white, 0 0 0 4px ${pearGreen}` },
          _active: { backgroundColor: pearGreenHover },
        },
        link: {
          color: pearGreen,
          _hover: { color: pearGreenHover, backgroundColor: "transparent" },
        },
      },
    },
  },
};

function Header() {
  return (
    <div className="flex flex-col items-center gap-3 pb-2">
      <img
        src={require("@/assets/pear_logo.svg").default}
        alt="Pear"
        className="h-9"
      />
      <p className="text-sm text-muted-foreground">Sign in to the care team portal</p>
    </div>
  );
}

export const StyledAuthenticator: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { fetchUser } = useAuthStore();

  useEffect(() => {
    fetchUser();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Authenticator
        hideSignUp
        className="auth-container"
        components={{ Header }}
      >
        {() => <>{children}</>}
      </Authenticator>
    </ThemeProvider>
  );
};
